import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
//import Papa from "papaparse";
import CustomStepper from "../components/CustomStepper2";
import CustomTabs from "../components/CustomTabs2";
import { Box } from "@mui/material";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DownloadIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import "../containers/Prompt.css";
import LoadingModal from "./LoadingModal"
import InsertsChecklist from "./InsertsCheckList";




export default function TabNTABS(props) {
  const { project, docRef, updateConfig, config, updateSteps, disabled, models } = props;
  const [tabStep, setTabStep] = useState(1);
  const [activeStep, setActiveStep] = React.useState(-1);


  const [tabProcess, setTabProcess] = useState(1);


  const [promptSysP0, setPromptSysP0] = useState("");
  const [promptUserP0, setPromptUserP0] = useState("");
  const [promptSysP1, setPromptSysP1] = useState("");
  const [promptUserP1, setPromptUserP1] = useState("");
  const [promptUserP2, setPromptUserP2] = useState("");
  const [promptSysP2, setPromptSysP2] = useState("");
  const [promptUserP3, setPromptUserP3] = useState("");
  const [promptSysP3, setPromptSysP3] = useState("");
  //const [sdoList, setSdoList] = useState("");
  const [validatorOptions, setValidatorOptions] = useState("");
  const [validatorResults, setValidatorResults] = useState("");
  const [enrichedNtab, setEnrichedNtab] = useState("");
  const [p0ResultsNtab, setP0ResultsNtab] = useState("");
  const [p1ResultsNtab, setP1ResultsNtab] = useState("");
  const [p2ResultsNtab, setP2ResultsNtab] = useState("");
  const [p3ResultsNtab, setP3ResultsNtab] = useState("");

  const [temperature, setTemperature] = useState(0.0);
  const [topP, setTopP] = useState(1.0);
  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);
  const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");


  const [ntabId, setNtabId] = useState(null);
  const [ntabArtefacts, setNtabArtefacts] = useState([]);


  const [copied, setCopied] = useState(false);

  const [prompt, setPrompt] = useState("");

  const [files, setFiles] = useState([]);
  const [processingState, setProcessingState] = useState({ currentIndex: 0, isActive: false, userKey: 1 });
  const [isRunning, setIsRunning] = useState(false);
  const [resultsStatus, setResultsStatus] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);
  const [resultsData, setResultsData] = useState("");
  const startTimeRef = useRef(0);
  const indexRef = useRef(0);
  const processTextRef = useRef("");



  const [statusText, setStatusText] = useState("");
  const [processText, setProcessText] = useState("");




  const [steps, setSteps] = useState([
    { id: 0, title: "P0", subtitle: "", code: "P0", extractionType: "p0", completed: false, exists: false, disabled: true},
    { id: 1, title: "P1", subtitle: "", code: "P1", extractionType: "p1", completed: false, exists: false, disabled: false },
    { id: 2, title: "P2", subtitle: "", code: "P2", extractionType: "p2", completed: false, exists: false, disabled: false },
    { id: 3, title: "P3", subtitle: "", code: "P3", extractionType: "p3", completed: false, exists: false, disabled: false },
    { id: 4, title: "Validation", code: "Validation", extractionType: "validation", subtitle: "", completed: false, exists: false, disabled: false },

  ]);


  useEffect(() => {
    updateTabsAndSteps();
    loadConfig();
  }, []);


  useEffect(() => {
    loadNTABArtefacts();
    clearResults();
    updateTabsAndSteps();
  }, [docRef.current]); //



  useEffect(() => {
    //console.log("polling");
    let pollingInterval;
    if (isRunning && ntabId) {
      pollingInterval = setInterval(pollNTABStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isRunning, ntabId]);

  useEffect(() => {
    let pollingInterval;
    if (isRunning) {
      pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
    }
    try {
      return () => {
        clearInterval(pollingInterval);
      } // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }
  }, [isRunning]); //

  const updateResultsStatus = () => {
    const timeDiff = (Date.now() - startTimeRef.current) / 1000;
    setResultsStatus(timeDiff)

  }
  function clearResults() {
    setP0ResultsNtab("");
    setP1ResultsNtab("");
    setP2ResultsNtab("");
    setP3ResultsNtab("");
    setValidatorResults("");
  }



  function updateTabsAndSteps() {
    const updatedSteps = [];
    for (const step of steps) {
      let updatedStep;
      console.log(step);
      if (docRef.current.parseState && docRef.current.parseState.ntabs) {
        if (docRef.current.parseState.ntabs[step.code]) {
          updatedStep = { ...step, exists: true, completed: docRef.current.parseState.ntabs[step.code].status == 1 }
        } else {
          updatedStep = { ...step, exists: false, completed: false }
        }
      } else {
        updatedStep = { ...step, exists: false, completed: false }
      }
      updatedSteps.push(updatedStep);
    }
    setSteps(updatedSteps);
    console.log(steps);
  }





  const loadNTABArtefacts = async () => {
    console.log(docRef.current.itemId);
    indexRef.current = 0;
    setProcessingState({ ...processingState, currentIndex: indexRef.current });
    startTimeRef.current = Date.now();
    setIsRunning(true);
    const arts = await getResults({ pk: docRef.current.itemId, sk: `ART|P1|`, mode: "query" });
    //const arts = await getArtefacts();
    const ntabArts = arts.data.filter(item => item.content.ntab_type && item.content.ntab_decision && item.content.ntab_type !== "" && item.content.ntab_decision === "approve");
    console.log(ntabArts);
    setNtabArtefacts(ntabArts);
    setIsRunning(false);
  }

  /*
  function getArtefacts() {
    return API.get("findigai", "/artefacts/" + docRef.current.itemId);
  }
    */

  function getOpenAI(body) {
    return API.post("findigai", "/openai", {
      body: body
    });
  }
  /*
  function getNTABResults(body) {
    return API.post("findigai", "/results", {
      body: body
    });
  }
    */
  function getResults(body) {
    return API.post("findigai", "/results/mode", {
      body: body
    });
  }

  function validate(body) {
    return API.post("findigai", "/validation", {
      body: body
    });
  }

  function handleTabChange(event, value) {
    event.preventDefault();
    console.log(value);
    setTabProcess(value);
    setTabStep(value);
  };





  const loadConfig = () => {
    const cf = config;
    setPromptUserP0(cf.ntabs.options.promptUserP0);
    setPromptSysP0(cf.ntabs.options.promptSysP0);
    setPromptUserP1(cf.ntabs.options.promptUserP1);
    setPromptSysP1(cf.ntabs.options.promptSysP1);
    setPromptUserP2(cf.ntabs.options.promptUserP2);
    setPromptSysP2(cf.ntabs.options.promptSysP2);
    setPromptUserP3(cf.ntabs.options.promptUserP3);
    setPromptSysP3(cf.ntabs.options.promptSysP3);
    //setSdoList(cf.ntabs.options.sdos);
    setValidatorOptions(cf.ntabs.options.validator);
    setTemperature(cf.ntabs.options.temperature);
    setTopP(cf.ntabs.options.topP);
    setPresencePenalty(cf.ntabs.options.presencePenalty);
    setFrequencyPenalty(cf.ntabs.options.frequencyPenalty);
    setSelectedModel(cf.ntabs.options.model);
  }

  const handleProcessNTABArtefactsClick = (event) => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    //updateSteps(1, true);
    clearResults();
    deleteAllExisting();
    initiatePipeLineForNextArtefact(0);
  }

  async function deleteAllExisting() {
    await getResults({ pk: docRef.current.itemId, sk: `GOL|`, mode: "delete-all" });
    await getResults({ pk: docRef.current.itemId, sk: `DOM|`, mode: "delete-all" });
    await getResults({ pk: docRef.current.itemId, sk: `TAB|`, mode: "delete-all" });
  }

  const initiatePipeLineForNextArtefact = async (artefactIndex) => {
    if (artefactIndex >= ntabArtefacts.length) {
      updateSteps(2, true);
      //downloadResults("P0", false);
      downloadResults("P1", false);
      downloadResults("P2", false);
      downloadResults("P3", false);
      downloadResults("VAL", false);

      setIsRunning(false);
      //alert("NTAB Extraction succeded");

    } else {
      setProcessingState({ ...processingState, currentIndex: artefactIndex });
      setProcessText("P1 querying");
      console.log(ntabArtefacts[processingState.currentIndex].content.ntab_type);
      await runPxQuery("P1", artefactIndex);
    }
  }

  function setValidationResults(rawResult) {
    console.log(rawResult);
    let errorHtml = "<b>unable to retrieve errors</b>";
    if (rawResult) {
      const errors = rawResult;//.data.content;
      errorHtml = "<b>no errors</b>";
      if (errors.length > 0) {
        let currentNtab = "";
        errors.forEach((error, index) => {
          if (currentNtab == "") {
            errorHtml = "<h6><b>" + error.ntabId + "</b></h6>";
            currentNtab = error.ntabId;
          } else if (currentNtab != error.ntabId) {
            errorHtml += "<br/><br/><h6><b>" + error.ntabId + "</b></h6>";
            currentNtab = error.ntabId;
          }
          errorHtml += "&nbsp;&nbsp;&nbsp;<b>" + error.type + "</b><br/>";
          Object.entries(error.details).forEach(([key, detail]) => {
            if (key == "fixes") {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fixes:<br/>";
              Object.entries(detail).forEach(([key2, detail2]) => {
                errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key2 + ": " + detail2 + "<br/>";
              });
            } else {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key + ": " + detail + "<br/>";
            }
          });
        });
      }
    }
    return errorHtml;
  }



  async function runPxQuery(type, artefactIndex) {
    console.log("=============================================")
    console.log(type, artefactIndex);
    console.log(ntabArtefacts[artefactIndex]);
    console.log("============================================")
    const newUserKey = processingState.userKey === 2 ? 1 : 2;
    setProcessingState({ ...processingState, userKey: newUserKey });
    let resultsStr = "";
    try {
      let artid = ntabArtefacts[artefactIndex].itemId;//sk.slice(7);
      const body = { type: "extraction", subtype: type, docid: docRef.current.itemId, artid, keyid: newUserKey, config: getConfigObj() }; //processId: processId, fileName: file.name, 
      const result = await getOpenAI(body);
      console.log(result);
      resultsStr = result.body;
      setNtabId(type);
      return { status: true, result: resultsStr };
    } catch (err) {
      console.log("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }


  const pollNTABStatus = async () => {
    //const ntabType = ntabId.startsWith("ntab") ? ntabId.slice(4) : "";
    //const body = { pk: docRef.current.itemId, sk: `TAB|${ntabType}|ART|${String(ntabArtefacts[indexRef.current].itemId).padStart(4, '0')}`, mode: "get" };
    //const result = await getNTABResults(body);
    let artid = ntabArtefacts[indexRef.current].itemId; //sk.slice(7);
    const result = await getResults({ pk: docRef.current.itemId, sk: `TAB|${ntabId}|ART|${artid}`, mode: "get" });
    //const result = await getResults({ pk: docRef.current.itemId, sk: `TAB|${ntabId}|ART|${String(ntabArtefacts[indexRef.current].itemId).padStart(4, '0')}`, mode: "get" });
    console.log(result);
    if (result.status && result.data && result.data.itemStatus > 0) {
      const currentNtabId = ntabId;
      setNtabId(null);
      if (currentNtabId == "P0") {
        if (result.data.approved && result.data.approved === "true") {
          console.log("P1 querying");
          setProcessText("P1 querying");
          runPxQuery("P1", indexRef.current);
        } else { //skip as not approved
          indexRef.current++;
          initiatePipeLineForNextArtefact(indexRef.current);
        }
      } else if (currentNtabId == "P1") {
        console.log("P2 querying");
        setProcessText("P2 querying");
        runPxQuery("P2", indexRef.current);
      } else if (currentNtabId == "P2") {
        console.log("P3 querying");
        setProcessText("P3 querying");
        runPxQuery("P3", indexRef.current);
      } else if (currentNtabId == "P3") {
        console.log("Validating");
        setProcessText("Validating");
        const valResult = await validate({ type: "MAIN-NTAB", prjid: project.itemId, docid: docRef.current.itemId, artid });
        console.log(valResult);
        indexRef.current++;
        initiatePipeLineForNextArtefact(indexRef.current);
      }
    } else if (result.error && result.findigCode && result.findigCode == 3) {
      // Do nowt ie record not yet created
    } else {
      setIsRunning(false);
      alert("NTAB Extraction Failed - see logs");
    }
  }


  const saveConfig = async () => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    const body = getConfigObj();
    await updateConfig(body);
    setIsRunning(false);
    // resetResults();
  }



  function getConfigObj() {
    return { type: "ntabs", values: { options: { promptSysP0: promptSysP0, promptUserP0: promptUserP0, promptSysP1: promptSysP1, promptUserP1: promptUserP1, promptSysP2: promptSysP2, promptUserP2: promptUserP2, promptSysP3: promptSysP3, promptUserP3: promptUserP3, /*sdos: sdoList,*/ model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty } } };
  }


  const handleTopPChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTopP(newValue);
  }
  const handleTemperatureChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTemperature(newValue);
  }
  const handlePresencePenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setPresencePenalty(newValue);
  }
  const handleFrequencyPenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setFrequencyPenalty(newValue);
  }

  const handleValidatorOnlyClick = async (event) => {
    //validateNTAB(enrichedNtab);

  }

  const copyToClipboard = (e, stage) => {
    e.preventDefault();
    let text = "";
    switch (stage) {
      case "P0":
        text = p0ResultsNtab;
        break;
     case "P1":
        text = p1ResultsNtab;
        break;
      case "P2":
        text = p2ResultsNtab;
        break;
      case "P3":
        text = p3ResultsNtab;
        break;
      case "VAL":
        text = validatorResults;
        break;
    }
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log("Text copied to clipboard!");
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // hide after 2 sec
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  }




  const downloadResults = async (stage, timer = false) => {
    if (timer) {
      startTimeRef.current = Date.now();
      setIsRunning(true);
    }
    // let body = { pk: docRef.current.itemId, sk: `TAB|${stage}|ART|`, mode: "query" };
    const results = await getResults({ pk: docRef.current.itemId, sk: `TAB|${stage}|ART|`, mode: "query" });
    let text = "";
    for (const tab of results.data) {
      if (stage === "VAL") {
        text += `<b>${tab.sk}</b> ----------------------------------------------------------------------------------------------------------------------------<br/><br/>`;
        text += setValidationResults(tab.content);
        text += `<br/>-------------------------------------------------------------------------------------------------------------------------------------<br/><br/>`;

      } else {
        text += `${tab.sk} ----------------------------------------------------------------------------------------------------------------------------\n`;
        text += tab.content;
        text += `\n-------------------------------------------------------------------------------------------------------------------------------------\n\n`;

      }
    }
    //console.log(text);
    switch (stage) {
      case "P0":
        setP0ResultsNtab(text);
        break;
      case "P1":
        setP1ResultsNtab(text);
        break;
      case "P2":
        setP2ResultsNtab(text);
        break;
      case "P3":
        setP3ResultsNtab(text);
        break;
      case "VAL":
        setValidatorResults(text);
        break;
    }
    if (timer) {
      setIsRunning(false);
    }
  }




  const loadResults = async (e, stage) => {
    e.preventDefault();
    downloadResults(stage, true);
  }

  function renderLander() {
    return (



      <Box p={0} sx={{ backgroundColor: "#fff" }}>
        <Box px={2} >
          <h6> {Number(resultsStatus) > 0 ? String(Number(resultsStatus).toFixed(1)) + " seconds." : ""}</h6>
        </Box>
        <Box px={2} my={2}>
          <Button disabled={ntabArtefacts.length == 0 || isRunning || docRef.current.itemStatus < 2} onClick={handleProcessNTABArtefactsClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run NTAB pipeline</Button>
        </Box>

        <CustomStepper steps={steps} activeStep={activeStep} />
        <Box px={1} sx={{
          width: '100%',
          bgcolor: 'white',
          color: 'white',
        }}>
          <CustomTabs
            tabs={steps}
            value={tabStep}
            onChange={handleTabChange}
          />
          <Box p={2} sx={{
            width: '100%',
            bgcolor: '#33337733',
            color: '#330',
          }}>






            <>



              <Box mt={1} sx={{ width: "100%" }}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>

                  <Box p={2}>



                    <Paper style={{ backgroundColor: "#efe" }}>
                      <Box p={1}>

{tabProcess == 0 ?
<>
                            <Paper style={{ backgroundColor: "#ffe" }}>
                              <Box p={1} mb={4}>

                                <Box display="flex" alignItems='center' flexDirection="row" >
                                  <Box pv={2} pl={0.5}>
                                    <h6>P0 results</h6>
                                  </Box>
                                  <Box sx={{ flexGrow: 1 }} ></Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="download existing results">
                                      <IconButton
                                        onClick={(e) => { loadResults(e, "P0") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="Copy results to clipboard">
                                      <IconButton
                                        onClick={(e) => { copyToClipboard(e, "P0") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <FileCopyIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                  </Box>
                                </Box>

                                <TextareaAutosize
                                  disabled={isRunning}
                                  minRows={1}
                                  placeholder="<empty>"
                                  value={p0ResultsNtab}
                                  onChange={(e) => setP0ResultsNtab(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}
                                />
                              </Box>
                            </Paper>







                            <Box pv={2} pl={0.5}>
                              <h6>System prompt (P0)</h6>
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptSysP0 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptSysP0(text)}
                                />
                              </Box>
                            </Paper>


                            <Box pt={3} pb={0} pl={0.5} >
                              <h6>User prompt (P0)</h6>
                            </Box>
                            <Box py={1}>
                              <InsertsChecklist inserts={["{{{tab-md}}}"]} text={promptUserP0} />
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptUserP0 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptUserP0(text)}
                                />
                              </Box>
                            </Paper>
</>

                         : tabProcess == 1 ?
                          <>

                            <Paper style={{ backgroundColor: "#ffe" }}>
                              <Box p={1} mb={4}>

                                <Box display="flex" alignItems='center' flexDirection="row" >
                                  <Box pv={2} pl={0.5}>
                                    <h6>P1 results</h6>
                                  </Box>
                                  <Box sx={{ flexGrow: 1 }} ></Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="download existing results">
                                      <IconButton
                                        onClick={(e) => { loadResults(e, "P1") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="Copy results to clipboard">
                                      <IconButton
                                        onClick={(e) => { copyToClipboard(e, "P1") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <FileCopyIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                  </Box>
                                </Box>

                                <TextareaAutosize
                                  disabled={isRunning}
                                  minRows={1}
                                  placeholder="<empty>"
                                  value={p1ResultsNtab}
                                  onChange={(e) => setP1ResultsNtab(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}
                                />
                              </Box>
                            </Paper>







                            <Box pv={2} pl={0.5}>
                              <h6>System prompt (P1)</h6>
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptSysP1 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptSysP1(text)}
                                />
                              </Box>
                            </Paper>


                            <Box pt={3} pb={0} pl={0.5} >
                              <h6>User prompt (P1)</h6>
                            </Box>
                            <Box py={1}>
                              <InsertsChecklist inserts={["{{{tab-md}}}"]} text={promptUserP1} />
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptUserP1 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptUserP1(text)}
                                />
                              </Box>
                            </Paper>

                          </>
                          : tabProcess == 2 ?
                            <>


                              <Paper style={{ backgroundColor: "#ffe" }}>
                                <Box p={1} mb={4}>



                                  <Box display="flex" alignItems='center' flexDirection="row" >
                                    <Box pv={2} pl={0.5}>
                                      <h6>P2 results</h6>
                                    </Box>
                                    <Box sx={{ flexGrow: 1 }} ></Box>
                                    <Box mx={1} pb={1}>
                                      <Tooltip title="download existing results">
                                        <IconButton
                                          onClick={(e) => { loadResults(e, "P2") }}
                                          disabled={isRunning}
                                          size="small"
                                        >
                                          <DownloadIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </Box>
                                    <Box mx={1} pb={1}>
                                      <Tooltip title="Copy results to clipboard">
                                        <IconButton
                                          onClick={(e) => { copyToClipboard(e, "P2") }}
                                          disabled={isRunning}
                                          size="small"
                                        >
                                          <FileCopyIcon />
                                        </IconButton>
                                      </Tooltip>
                                      {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                    </Box>
                                  </Box>




                                  <TextareaAutosize
                                    disabled={true}
                                    placeholder="<empty>"
                                    minRows={1}
                                    value={p2ResultsNtab}
                                    onChange={(e) => setP2ResultsNtab(e.target.value)}
                                    style={{
                                      width: '100%',
                                      padding: '12px',
                                      fontSize: '16px',
                                      borderRadius: '8px',
                                      border: '1px solid #ccc',
                                      resize: 'vertical',
                                    }}

                                  />

                                </Box>
                              </Paper>

                              <Box pv={2} pl={0.5}>
                                <h6>System prompt (P2)</h6>
                              </Box>
                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptSysP2 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptSysP2(text)}
                                  />
                                </Box>
                              </Paper>

                              <Box pt={3} pb={0} pl={0.5} >
                                <h6>User prompt (P2)</h6>
                              </Box>
                              <Box py={1}>
                                <InsertsChecklist inserts={["{{{p1-tab}}}", "{{{sdo-list}}}"]} text={promptUserP2} />
                              </Box>

                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptUserP2 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptUserP2(text)}
                                  />
                                </Box>
                              </Paper>
                              {/*}
                              <Box pv={2} pl={0.5}>
                                <h6>SDOs (in CSV table format)</h6>
                              </Box>



                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={sdoList}
                                onChange={(e) => setSdoList(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />
                              */}

                            </>
                            : tabProcess == 3 ?
                              <>


                                <Paper style={{ backgroundColor: "#ffe" }}>
                                  <Box p={1} mb={4}>



                                    <Box display="flex" alignItems='center' flexDirection="row" >
                                      <Box pv={2} pl={0.5}>
                                        <h6>P3 results (Enriched NTAB)</h6>
                                      </Box>
                                      <Box sx={{ flexGrow: 1 }} ></Box>
                                      <Box mx={1} pb={1}>
                                        <Tooltip title="download existing results">
                                          <IconButton
                                            onClick={(e) => { loadResults(e, "P3") }}
                                            disabled={isRunning}
                                            size="small"
                                          >
                                            <DownloadIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                      <Box mx={1} pb={1}>
                                        <Tooltip title="Copy results to clipboard">
                                          <IconButton
                                            onClick={(e) => { copyToClipboard(e, "P3") }}
                                            disabled={isRunning}
                                            size="small"
                                          >
                                            <FileCopyIcon />
                                          </IconButton>
                                        </Tooltip>
                                        {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                      </Box>
                                    </Box>


                                    <TextareaAutosize
                                      disabled={isRunning}
                                      minRows={1}
                                      placeholder="<empty>"
                                      value={p3ResultsNtab}
                                      onChange={(e) => setP3ResultsNtab(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '12px',
                                        fontSize: '16px',
                                        borderRadius: '8px',
                                        border: '1px solid #ccc',
                                        resize: 'vertical',
                                      }}
                                    />
                                  </Box>
                                </Paper>

                                <Box pv={2} pl={0.5}>
                                  <h6>System prompt (P3)</h6>
                                </Box>

                                <Paper style={{ backgroundColor: "#fff" }}>
                                  <Box p={1}>
                                    <HighlightWithinTextarea
                                      disabled={isRunning}
                                      placeholder="<empty>"
                                      value={promptSysP3 ?? ""}
                                      highlight={[
                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                      ]}
                                      onChange={(text) => setPromptSysP3(text)}
                                    />
                                  </Box>
                                </Paper>

                                <Box pt={3} pb={0} pl={0.5} >
                                  <h6>User prompt (P3)</h6>
                                </Box>
                                <Box py={1}>
                                  <InsertsChecklist inserts={["{{{p2-tab}}}"]} text={promptUserP3} />
                                </Box>
                                <Paper style={{ backgroundColor: "#fff" }}>
                                  <Box p={1}>
                                    <HighlightWithinTextarea
                                      disabled={isRunning}
                                      placeholder="<empty>"
                                      value={promptUserP3 ?? ""}
                                      highlight={[
                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                      ]}
                                      onChange={(text) => setPromptUserP3(text)}
                                    />
                                  </Box>
                                </Paper>

                              </>
                              :
                              <>
                                {/*}
                                <Box p={2} mb={1}>
                                  <Button disabled={enrichedNtab == "" || isRunning} onClick={handleValidatorOnlyClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run Validator ONLY</Button>
                                </Box>

                                <Box pv={2} pl={0.5}>
                                  <h6>Enriched NTAB (as CSV)</h6>
                                </Box>


                                <TextareaAutosize
                                  disabled={isRunning}
                                  minRows={1}
                                  placeholder="<empty>"
                                  value={enrichedNtab}
                                  onChange={(e) => setEnrichedNtab(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}
                                />
                                */}




                                <Box display="flex" alignItems='center' flexDirection="row" >
                                  <Box pv={2} pl={0.5}>
                                    <h6>Validation Results</h6>
                                  </Box>
                                  <Box sx={{ flexGrow: 1 }} ></Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="download existing results">
                                      <IconButton
                                        onClick={(e) => { loadResults(e, "VAL") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="Copy results to clipboard">
                                      <IconButton
                                        onClick={(e) => { copyToClipboard(e, "VAL") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <FileCopyIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                  </Box>
                                </Box>

                                <Box sx={{ p: 2, border: "1px solid #ccc" }}
                                  dangerouslySetInnerHTML={{ __html: validatorResults }}>
                                </Box>

                              </>
                        }



                      </Box>
                    </Paper>


                    {tabProcess < 4 &&
                      <>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={temperature}
                                onChange={handleTemperatureChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Temperature</h6>
                          </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={topP}
                                onChange={handleTopPChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Top P</h6>
                          </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={presencePenalty}
                                onChange={handlePresencePenaltyChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Presence penalty</h6>
                          </Box>
                        </Box>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={frequencyPenalty}
                                onChange={handleFrequencyPenaltyChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Frequency penalty</h6>
                          </Box>
                        </Box>

                        <Box my={2} ml={0.5}>
                          <select
                            id="model"
                            disabled={isRunning}
                            value={selectedModel}
                            onChange={(e) => setSelectedModel(e.target.value)}
                          >
                            {models.map((model) => (
                              <option key={model.value} value={model.value}>
                                {model.label}
                              </option>
                            ))}
                          </select>

                        </Box>


                        <Box pt={3} pb={0} pl={0.5} >
                          <p style={{ fontSize: "0.75rem" }}><i>Note: To save the prompts and params without running the query use the SAVE button. The prompts and params will be automatically saved if you run the query.</i></p>
                        </Box>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>
                          <Box sx={{ flexGrow: 1 }} ></Box>
                          <Box my={2} mr={3}>
                            <Button
                              variant="contained" component="span"
                              disabled={isRunning}
                              onClick={(e) => {
                                e.preventDefault();
                                saveConfig();
                              }} color="primary">
                              Save
                            </Button>
                          </Box>
                        </Box>




                      </>
                    }


                  </Box>
                </Paper>
              </Box>



            </>






          </Box>
          <Box p={2} sx={{
            width: '100%',
            bgcolor: 'white',
            color: 'white',
          }}>
          </Box>
        </Box>

      </Box>

    )
  }
  return (
    <>
      {renderLander()}
      {ntabArtefacts && ntabArtefacts.length > 0 && ntabArtefacts[indexRef.current] && ntabArtefacts[indexRef.current].content && ntabArtefacts[indexRef.current].content.related_ntabs &&
        <LoadingModal open={isRunning} message={indexRef.current > -1 ? `Artefact: ${indexRef.current + 1}/${ntabArtefacts.length} relntabs: ${ntabArtefacts[indexRef.current].content.related_ntabs}` : "Processing..."} message2={processText + "..."} message3={Number(resultsStatus).toFixed(1) + " seconds"} />
      }
    </>
  )
}